"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const starfilled = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-starfilled` : '') + (description ? ` desc-starfilled` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-starfilled"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-starfilled"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.998.75c.308 0 .59.172.73.446l3.345 6.629 6.44.638a.805.805 0 0 1 .5 1.374l-5.3 5.253 1.965 7.138a.813.813 0 0 1-.698 1.017l-.115.004a.811.811 0 0 1-.338-.086l-6.529-3.233-6.52 3.229a.812.812 0 0 1-.222.074l-.116.012a.813.813 0 0 1-.813-1.021l1.965-7.138L.988 9.833a.805.805 0 0 1 .5-1.374l6.44-.638 3.341-6.625A.819.819 0 0 1 12 .75Z",
    fill: "inherit"
  }));
};
var _default = exports.default = starfilled;